(() => {
  // Multiple sections and Shopify theme-editor reloads share one initializer.
  if (window.arcticInfoInitialized) return;
  window.arcticInfoInitialized = true;
  function init(root = document) {
    root.querySelectorAll('[data-arctic-info]').forEach(page => {
      if (page.dataset.ready) return;
      page.dataset.ready = 'true';
      const topic = page.querySelector('[data-contact-topic]');
      if (topic) {
        const order = page.querySelector('[data-contact-order]');
        const selling = page.querySelector('[data-contact-selling]');
        const sync = () => {
          const showOrder = ['Bestilling', 'Retur'].includes(topic.value);
          order.hidden = !showOrder;
          order.querySelector('input').disabled = !showOrder;
          selling.hidden = topic.value !== 'Selge samlekort';
        };
        // Never overwrite recovered form values or text entered by the customer.
        if (new URLSearchParams(location.search).get('tema') === 'selge-kort' && topic.value === 'Annet') topic.value = 'Selge samlekort';
        topic.addEventListener('change', sync);
        page.querySelectorAll('[data-contact-sell]').forEach(link => link.addEventListener('click', () => {
          topic.value = 'Selge samlekort';
          sync();
          requestAnimationFrame(() => topic.focus({ preventScroll: true }));
        }));
        sync();
        window.addEventListener('pageshow', sync);
      }
      const status = page.querySelector('[data-form-status]');
      if (status) status.focus({ preventScroll: false });
      const track = page.querySelector('[data-gallery-track]');
      if (track) {
        const nav = page.querySelector('[data-gallery-nav]');
        const prev = nav.querySelector('[data-gallery-prev]');
        const next = nav.querySelector('[data-gallery-next]');
        function update() {
          const max = Math.max(0, track.scrollWidth - track.clientWidth);
          nav.hidden = max < 2;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= max - 2;
        }
        function step(direction) {
          const item = track.querySelector('figure');
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          track.scrollBy({ left: direction * ((item?.getBoundingClientRect().width || track.clientWidth) + gap), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
        prev.addEventListener('click', () => step(-1));
        next.addEventListener('click', () => step(1));
        track.addEventListener('scroll', update, { passive: true });
        track.addEventListener('keydown', e => {
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); step(e.key === 'ArrowLeft' ? -1 : 1); }
        });
        if ('ResizeObserver' in window) {
          const observer = new ResizeObserver(update);
          observer.observe(track);
          const unload = e => { if (e.target.contains(page)) { observer.disconnect(); document.removeEventListener('shopify:section:unload', unload); } };
          document.addEventListener('shopify:section:unload', unload);
        } else window.addEventListener('resize', update);
        update();
      }
    });
  }
  init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
